// Libs
import { createSelector } from 'reselect'
import _find from 'lodash/find'

// Selectors
import { environment$ } from 'fc-environment'
import { farms$ } from 'fc-assets'

// Model Properties
import {
  PROP_ASSET_ID,
} from 'fc-model-assets'

// Utils
import traverse from 'fc-utils/traverse'

// Local Utils
const getFarmIdFromEnv = traverse(['hfty-selected-farm', 'value', Number])

// Exports
export default createSelector(
  [environment$, farms$],
  (environment, farms) => {
    const farmId = getFarmIdFromEnv(environment)
    if (farmId) {
      const farm = _find(farms, { [PROP_ASSET_ID]: farmId })

      if (farm) {
        return farmId
      }
    }

    return null
  })
